import React from 'react'

import MediaQuery from 'react-responsive'

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Button from '@mui/material/Button';

const Information = () => {
  return (
    <Box>
        <MediaQuery maxWidth={576}>
            <Box  >
                <Box sx={{ display:'flex', alignItems:'center', flexDirection: 'column'}}>
                    <Avatar alt=" " src='../img/1.png' sx={{ width: 150, height: 150, boxShadow: '0px 4px 4px 2px rgba(0, 0, 0, 0.25) ', margin: '10px 0px' }} />
                    <Typography variant="h4" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 28 }}>
                        Luis Gabriel G. Millares
                    </Typography>
                    
                    <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, color: '#797979'}} >
                        Computer Engineer
                    </Typography>
                </Box>
                <Box sx={{ textAlign:'center' }}>
                    <IconButton href="http://www.github.com/millaresluis" target= '_blank'>
                        <GitHubIcon/>
                    </IconButton>
                    <IconButton href="http://www.linkedin.com/in/millaresluis" target= '_blank'>
                        <LinkedInIcon/>
                    </IconButton>
                </Box>
                <Box sx={{ textAlign:'center', paddingBottom:2 }} >
                    <Button sx={{":hover":{backgroundColor:'rgba(0, 0, 0, 0.54)'} ,backgroundColor: 'rgba(0, 0, 0, 0.54)', height: 25, borderRadius: 5, width:'35%' }} variant="contained" href="https://drive.google.com/file/d/17IhqsA07_FbKOyazKg-e97Gzoek_lz8Q/view?usp=sharing" target='_blank'>
                        <Typography  sx={{fontFamily: 'Merriweather', fontSize: 12, textAlign:'center' }}>
                            View Resume
                        </Typography>
                    </Button>
                </Box>
            </Box> 
        </MediaQuery>

        <MediaQuery minWidth={576}>
            <Box sx={{ display:'flex', padding: '20px 20px 10px 20px' }} >
                <Box>
                    <Avatar alt=" " src='../img/Profile.jpg' sx={{ width: 150, height: 150, boxShadow: '0px 4px 4px 2px rgba(0, 0, 0, 0.25) ' }} />
                </Box>
                <Box sx= {{  padding:'30px 20px',  }}>
                    <Typography variant="h4" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 28 }}>
                        Luis Gabriel G. Millares
                    </Typography>
                    
                    <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, color: '#797979' }} >
                        Computer Engineer
                    </Typography>

                    <IconButton href="http://www.github.com/millaresluis" target= '_blank'>
                        <GitHubIcon/>
                    </IconButton>
                    <IconButton href="http://www.linkedin.com/in/millaresluis" target= '_blank'>
                        <LinkedInIcon/>
                    </IconButton>
                    <Button color='info' sx={{ ":hover":{backgroundColor:'rgba(0, 0, 0, 0.54)'} ,backgroundColor: 'rgba(0, 0, 0, 0.54)', height: 25, borderRadius: 5, width:'37%' }} variant="contained" href="https://drive.google.com/file/d/1gBmz24twmmRoIzVTJxvqOd0kT5G8BQtW/view?usp=sharing" target='_blank'>
                        <Typography  sx={{ fontFamily: 'Merriweather', fontSize: 12 }}>
                            View Resume
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </MediaQuery>
    </Box>
  )
}

export default Information